<template>
  <div @keypress.enter="onSubscribe"
       class="auth"
  >
    <BaseInput type="text"
               v-model="inputs.name.value"
               :error="inputs.name.error"
               :placeholder="$t(`Ім'я`)"
               class="auth__input"
    />
    <BaseInput type="email"
               v-model="inputs.email.value"
               :error="inputs.email.error"
               placeholder="Email"
               class="auth__input"
    />

    <BaseAlertInline :value="overallErrorsMix"
                     class="_warning"
    />

    <div class="auth__buttons">
      <button @click.prevent="onSubscribe"
              class="auth__btn base-btn"
      >
        {{$t('Підписатися')}}
      </button>
    </div>
  </div>
</template>

<script>
  import formMixins from '../mixins/formMixins'
  import {http} from '../axios'

  export default {
    mixins: [formMixins],
    name: 'Subscribe',
    data() {
      return {
        inputs: {
          name: {
            value: null
          },
          email: {
            value: null
          }
        }
      }
    },
    methods: {
      onSubscribe() {
        this.resetErrorsMix(this.inputs)

        http.post('api/feedback/subscribe', this.createSendDataMix(this.inputs))
          .then((data) => {
            this.$vModal.close('subscribe')
            this.$nextTick(() => {
              this.$vModal.open('message', {
                title: data.data.message,
                type: data.data.status
              })
            })
          }).catch(e => {
          this.handlerErrorMix(e, this.inputs)
        })
      }
    }
  }
</script>

<style lang="less">

</style>
